import { useEffect, useState } from "react";

import { Order } from "@web-app/types";

interface UseInvalidTimestampDetectionProps {
  orderIds?: string[];
  orders?: Map<string, Order>;
}

export function useInvalidTimestampDetection({
  orderIds,
  orders,
}: UseInvalidTimestampDetectionProps) {
  const [invalidTimestampOrders, setInvalidTimestampOrders] = useState<
    string[]
  >([]);

  useEffect(() => {
    const invalidOrders: string[] = [];

    if (!orders) {
      setInvalidTimestampOrders([]);
      return;
    }

    const ordersToCheck = orderIds
      ? orderIds.map((id) => orders.get(id)).filter((o): o is Order => !!o)
      : Array.from(orders.values());

    const now = new Date();

    for (const order of ordersToCheck) {
      const scheduledStart = new Date(order.scheduledStartDateTime);
      const scheduledEnd = new Date(order.scheduledEndDateTime);

      // Check if scheduled end is before scheduled start (invalid time window)
      if (scheduledEnd < scheduledStart) {
        invalidOrders.push(order.externalId || order.displayId);
        continue;
      }

      // Check if scheduled end is in the past (more than 1 day ago to account for timezone issues)
      const oneDayAgo = new Date(now);
      oneDayAgo.setDate(oneDayAgo.getDate() - 1);

      if (scheduledEnd < oneDayAgo) {
        invalidOrders.push(order.externalId || order.displayId);
      }
    }

    setInvalidTimestampOrders(invalidOrders);
  }, [orders, orderIds]);

  return {
    hasInvalidTimestamps: invalidTimestampOrders.length > 0,
    invalidTimestampOrders,
  };
}
